<template>
  <div>
    <img class="main-img" src="@/assets/img/bg.jpg" />
    <div class="box">
      <img class="box__img" src="@/assets/img/me-1.jpeg" />
      <div class="box__content">
        <section>
          <h2>Hello</h2>
          <p>
            I'm <strong>Harry</strong>, your dedicated professional gardener
            serving <strong>Sussex</strong>. 🌳
          </p>
          <p>
            Holding
            <strong
              >RHS Level 2 qualifications in Horticulture and Garden
              Design</strong
            >
            from Plumpton College, I provide reliable, knowledgeable maintenance
            and seasonal care for your outdoor space.
          </p>
          <p>
            My focus is on helping your garden remain healthy, vibrant, and
            enjoyable all year. I use an
            <strong>eco-friendly, wildlife-first approach</strong> to ensure
            your garden is not just beautiful, but also a thriving, sustainable
            habitat.
          </p>
          <p>
            Ready to see your garden flourish?
            <a href="/contact"><strong>Contact me today</strong></a
            >&mdash;I'd love to chat about your gardening needs!
          </p>
          <a href="https://www.rhs.org.uk/" target="_blank">
            <img class="rhs-logo" src="@/assets/icons/rhs-logo.svg" />
          </a>
        </section>
      </div>
    </div>
    <div class="services-container">
      <h2>Gardening Services 🌿</h2>
      <ul class="services-list">
        <li class="service-item">Planting plans</li>
        <li class="service-item">Mowing</li>
        <li class="service-item">Weeding</li>
        <li class="service-item">Wildlife Habitats</li>
        <li class="service-item">Hedge Cutting</li>
        <li class="service-item">Fruit tree Pruning</li>
        <li class="service-item">Planting Trees and Plants</li>
        <li class="service-item">Creating Beds</li>
        <li class="service-item">Mulching</li>
        <li class="service-item">Strimming</li>
        <li class="service-item">Raised beds</li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  name: 'App',
}
</script>

<style lang="scss">
// 🌿 SCSS Variables
$primary-color: #3e6549; // Dark green for text/accents
$secondary-color: #2c5f2d; // Slightly darker green for headers
$light-background: #f2f6f3; // Very light green/off-white background
$light-border: #d4e7d4; // Light green border
$shadow: rgba(0, 0, 0, 0.1);

.rhs-logo {
  width: 100px;
}

.services-container {
  max-width: 700px;
  margin: 0 auto;
  padding: 20px;
  font-family: Arial, sans-serif;

  h2 {
    text-align: center;
    margin-bottom: 30px;
    color: $secondary-color;
  }
}

// 🌳 Flexbox Styling for the List 🌳
.services-list {
  list-style: none;
  padding: 0;
  margin: 0;

  // --- Flexbox Properties ---
  display: flex;
  flex-wrap: wrap;
  justify-content: space-around;
  gap: 20px;

  .service-item {
    // Flex properties
    flex-basis: 270px;
    flex-grow: 1;

    // Visual Styling
    padding: 20px;
    border: 1px solid $light-border;
    border-radius: 8px;
    text-align: center;
    font-size: 1.1em;
    font-weight: bold;
    background-color: $light-background;
    color: $primary-color;
    box-shadow: 0 4px 6px $shadow;
    transition:
      transform 0.3s ease,
      box-shadow 0.3s ease;

    // SCSS Nesting for hover effect
    &:hover {
      transform: translateY(-5px);
      box-shadow: 0 6px 10px rgba(0, 0, 0, 0.15);
      cursor: default;
    }
  }
}

// Optional: Media Query (can also be nested inside .services-list)
@media (max-width: 600px) {
  .service-item {
    // On small screens, make items take up the full width
    flex-basis: 100%;
  }
}

.main-img {
  max-width: 100%;
}

.container {
  background-color: var(--nav-color);
}

@media screen and (min-width: 390px) and (max-width: 767px) {
  .container {
    height: 100%;
  }
}

.box {
  margin: auto;
  position: relative;
  background-color: white;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 20px;
  padding-top: 50px;

  @media screen and (min-width: 900px) {
    flex-direction: row;
    top: -390px;
    margin-bottom: -390px;
    align-items: normal;
    padding: 0;
  }

  @media screen and (min-width: 900px) {
    width: 900px;
  }

  &__img {
    width: 50%;
    img {
      max-width: 100%;
    }
  }

  &__content {
    @media screen and (min-width: 767px) {
      width: 50%;
      padding: 50px;
    }

    h2 {
      text-align: center;
      padding: 15px;
      color: #3e6549;

      @media screen and (min-width: 767px) {
        padding: 0;
      }
    }
  }
}
</style>
